import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { reportsStore } from '../../store/reportsStore';
import { IFranchiseeForSelect } from '../../components/ReportsFranchiseePicker/ReportsFranchiseePicker';
import HoursSales from './containers/HoursSales/HoursSales';
import DayWeekSales from './containers/DayWeekSales/DayWeekSales';
import MonthYearSales from './containers/MonthYearSales/MonthYearSales';
import { SCREENS } from 'src/constants/screens';
import { Table } from 'src/view/components/Table/Table';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import ScreenTabsNavigation from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import { userStore } from '~/mobx/userStore';
import { localeStore } from '~/mobx/localesStore';
import { appStore } from '~/mobx/appStore';

const SalesPeriod = () => {
  useEffect(() => {
    getActualBranches();
  }, []);

  const getActualBranches = async () => {
    const isNeedUpdateFilters = reportsStore.filters[appStore.isAddonsAvailable.franchise ? 'franchisee' : 'branches'];
    if (isNeedUpdateFilters) {
      await userStore.updateUser();
      const allUserBranches = await userStore.getAllBranches();

      const allFranchisees: IFranchiseeForSelect = {
        id: 0,
        name: localeStore.t('all_franchises'),
        data: allUserBranches,
      };

      reportsStore.updateFilters([{ ...allFranchisees, label: allFranchisees.name, value: allFranchisees.id }]);
    }
  };

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="sales_period" path={SCREENS.REPORTS()} />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 pt-6">
        <Table>
          <>
            <ScreenTabsNavigation
              options={[
                { path: SCREENS.HOURS_SALES(), title: 'sales_per_hours' },
                { path: SCREENS.DAY_WEEK_SALES(), title: 'daily_weekly_sales' },
                { path: SCREENS.MONTH_YEAR_SALES(), title: 'monthly_sales' },
              ]}
            />
            <Route path={SCREENS.HOURS_SALES()} component={HoursSales} />
            <Route path={SCREENS.DAY_WEEK_SALES()} component={DayWeekSales} />
            <Route path={SCREENS.MONTH_YEAR_SALES()} component={MonthYearSales} />
          </>
        </Table>
      </div>
    </div>
  );
};

export default SalesPeriod;
